import React, { useState } from 'react';
import { IonButton, IonContent, IonActionSheet } from '@ionic/react';
import { _dict } from '../constants';
import { useGlobalStore } from '../stateManagement/globalZustand';

interface ResetChoicesProps {
    onChoiceSelected: (choice: number) => void;
    setShowResetChoices: (show: boolean) => void;
}

const ResetChoices: React.FC<ResetChoicesProps> = ({ onChoiceSelected,setShowResetChoices }) => {
    const [showActionSheet, setShowActionSheet] = useState<boolean>(true);
    const {lang} = useGlobalStore();

    return (
        <>
            <IonActionSheet
                isOpen={showActionSheet}
                onDidDismiss={() => {
                    setShowActionSheet(false);
                    setShowResetChoices(false);
                }}
                buttons={[
                    {
                        text: _dict.atTopLeftCorner[lang],
                        handler: () => {
                            onChoiceSelected(1);
                        }
                    },
                    {
                        text: _dict.atLastStoredPositions[lang],
                        handler: () => {
                            onChoiceSelected(2);
                        }
                    },
                    {
                        text: _dict.inAGridLikePositions[lang],
                        handler: () => {
                            onChoiceSelected(3);
                        }
                    }
                ]}
            ></IonActionSheet>
        </>
    );
};

export default ResetChoices;
